// The names to offer when assigning leads, projects, etc. Source of truth is
// the backend team list (org-scoped once multi-tenancy ships). Until a member
// exists there, we fall back to the people added during onboarding, so a new
// workspace only ever sees its own users -- never another tenant's.
export function onboardingMemberNames() {
  try {
    const p = JSON.parse(localStorage.getItem('ryzenos_company_profile') || 'null');
    if (p && Array.isArray(p.members)) {
      return p.members.map(m => (m.name || m.email || '').trim()).filter(Boolean);
    }
  } catch {}
  return [];
}
